import styled from "styled-components";

export const StyledCashFlowTransactionsWrapper = styled.div`
  .payments-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 1fr;
    grid-gap: 25px;
    &__left {
      display: grid;
      align-items: center;
      grid-template-columns: repeat(2, max-content) 175px;
      grid-template-rows: 1fr;
      grid-gap: 20px;
      @media screen and (max-width: 576px) {
        grid-template-columns: 175px max-content;
      }
    }
    @media screen and (max-width: 992px) {
      grid-template-columns: repeat(2, max-content);
      grid-gap: 20px;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }

    &__create-invoice {
      display: inline-grid;
      align-items: center;
      justify-content:  end;
      @media screen and (max-width: 992px) {
        justify-content:  start;
      }
    }
  }
  .payment-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }
  .payment-table {
    &__head, &__row {
      grid-template-columns: repeat(3, minmax(210px, .85fr)) repeat(13, minmax(150px, 1fr)) minmax(210px, .85fr) 220px;
    }
    .note {
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      @media screen and (max-width: 992px) {
        max-width: 100%;
        white-space: inherit;
        overflow: inherit;
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
    @media screen and (max-width: 992px) {
      min-width: 100%;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__note {
        grid-column-start: 1;
        grid-column-end: 3;
      }
      .icon-light-info {
        display: none;
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__note {
        grid-column-end: 1;
      }
    }
  }
`;